import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Panel } from '@/components/Panel';
import { HeritageSeal } from '@/components/BrandMark';
import { Shield } from 'lucide-react';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const isAdminHint = params.get('admin') === '1';

  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const u = await login(form.email, form.password);
      const dest =
        u.role === 'admin' ? '/admin' :
        u.role === 'founder' ? '/console/founder' :
        u.role === 'ambassador' ? '/console/ambassador' :
        '/console/customer';
      navigate(location.state?.from || dest);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <Panel className="p-10">
        <div className="text-center">
          <HeritageSeal size={72} />
          <div className="h-eyebrow mt-4">{isAdminHint ? 'Admin' : 'Members'}</div>
          <div className="h-display text-3xl mt-1" style={{ color: 'var(--heritage-plum)' }}>
            {isAdminHint ? 'Staff Sign in' : 'Sign in'}
          </div>
          {isAdminHint && (
            <div className="mt-2 h-eyebrow flex items-center justify-center gap-2" style={{ color: 'var(--heritage-plum)' }}>
              <Shield size={12} /> Restricted access
            </div>
          )}
        </div>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="h-label">Email</label>
            <input className="h-input" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email" />
          </div>
          <div>
            <label className="h-label">Password</label>
            <input className="h-input" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password" />
          </div>
          <button className="h-btn w-full justify-center" disabled={loading} data-testid="login-submit">{loading ? 'Signing in...' : 'Sign in'}</button>
          {error && <div className="text-red-600 text-sm">{error}</div>}
        </form>
        {!isAdminHint && (
          <>
            <div className="text-center mt-6 text-sm" style={{ color: 'var(--heritage-plum)' }}>
              Not yet a member? <Link to="/founders-club" className="underline">Apply to the Founders Club</Link>
            </div>
            <div className="text-center mt-2 text-xs opacity-70" style={{ color: 'var(--heritage-plum)' }}>
              Or <Link to="/register" className="underline">create a general account</Link>
            </div>
          </>
        )}
      </Panel>
    </div>
  );
}
